// extracted by mini-css-extract-plugin
export var pageContainer = "styles-module--pageContainer--1m4fN";
export var info = "styles-module--info--3gGb5";
export var header = "styles-module--header--1ud4d";
export var description = "styles-module--description--11_ra";
export var link = "styles-module--link--YTbkt";
export var image = "styles-module--image--3HbuY";